var React = require('react');

function GovernmentIcon (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#d8b171"},[React.createElement("path",{"d":"m4.5 24h39c.825 0 1.5-.675 1.5-1.5v-3c0-.815625-.675-1.5-1.5-1.5h-1.77c-1.2675-7.51875-7.201875-13.464375-14.73-14.73v-1.77c0-.8203125-.675-1.5-1.5-1.5h-3c-.815625 0-1.5.6796875-1.5 1.5v1.77c-7.51875 1.265625-13.464375 7.21125-14.73 14.73h-1.77c-.8203125 0-1.5.684375-1.5 1.5v3c0 .825.6796875 1.5 1.5 1.5z","key":0}),React.createElement("path",{"d":"m48 43.5v3c0 .8240625-.675 1.5-1.5 1.5h-45c-.82509375 0-1.5-.675-1.5-1.5v-3c0-.825.67490625-1.5 1.5-1.5h1.5v-3c0-1.6565625 1.3434375-3 3-3v-12h6v12h9v-12h6v12h9v-12h6v12c1.6565625 0 3 1.3434375 3 3v3h1.5c.825 0 1.5.675 1.5 1.5z","opacity":".4","key":1})]));
}

GovernmentIcon.defaultProps = {"height":"48","viewBox":"0 0 48 48","width":"48"};

module.exports = GovernmentIcon;

GovernmentIcon.default = GovernmentIcon;
